module.exports = __webpack_public_path__ + "static/media/TP_Icon_BlueLightGlasses.260c9aae.png";